import { Collapse } from "antd";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import "./Questions.scss";
import { useEffect, useState } from "react";
import minus from "../../assets/images/pages/questions/Minus.svg";
import plus from "../../assets/images/pages/questions/Plus.svg";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import { FaqDataType } from "../../interface/site.interface";
import { FaqService } from "../../services/faq.service";
import Spinner from "../../components/shared/spinner/Spinner";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface Props {
  isAccount: boolean;
}

const Questions = ({ isAccount }: Props) => {
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [loading, setLoading] = useState<boolean>(false);
  const [faq, setFaq] = useState<FaqDataType[]>([]);
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);

  const handleChange = (key: string | string[]) => {
    setActiveKey(key?.toString() || null);
  };
  useEffect(() => {
    setLoading(true);
    FaqService.getAllFaq()
      .then((res) => setFaq(res?.data?.original))
      .finally(() => setLoading(false));
  }, [language]);
  const collapseItems = faq?.map((item, idx) => ({
    key: String(idx),
    label: (
      <div className="header_content">
        <TitleUpdater
          title={
            data?.colibri && data?.faq
              ? `${data?.colibri} | ${data?.faq}`
              : "Colibri"
          }
        />
        <h2 className="question">
          <div className={`icon ${activeKey === String(idx) ? "rotate" : ""}`}>
            <img
              src={activeKey === String(idx) ? minus : plus}
              alt=""
              useMap=""
            />
          </div>
          {item.questions}
        </h2>
      </div>
    ),
    children: (
      <div
        dangerouslySetInnerHTML={{
          __html: item.answers,
        }}
      />
    ),
  }));
  return (
    <div id="questions_page">
      <div className="container">
        {loading ? (
          <Spinner />
        ) : (
          <div className="questions">
            <h1 className="page_title">{data?.faq}</h1>
            <div className="questions_collapse">
              <div className={` collapse ${isAccount ? "user_collapse" : ""}`}>
                <Collapse
                  accordion
                  bordered={false}
                  defaultActiveKey={["0"]}
                  items={collapseItems}
                  onChange={handleChange}
                />
              </div>
            </div>
            <MobileAppSection />
          </div>
        )}
      </div>
    </div>
  );
};

export default Questions;
